import { useEffect, useState } from 'react';

import { AxiosError } from 'axios';

import { useHttp } from '@publicisgroupe/p-os-components';

import FeaturesApi from 'api/featuresApi';

export default function useFeatureFlags() {
  const http = useHttp();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [loadingError, setLoadingError] = useState<string | undefined>();
  const [featureFlags, setFeatureFlags] = useState<Record<string, boolean>>({});

  const setError = (error?: string) => {
    setIsLoading(false);
    setLoadingError(error ?? 'An error occured while loading feature flags');
  };

  const setFeatures = (features: Record<string, boolean>) => {
    setIsLoading(false);
    setFeatureFlags(features);
  };

  useEffect(() => {
    if (!http) {
      setError('Could not get HTTP object');
      return;
    }

    const featuresApi = FeaturesApi(http);
    if (!featuresApi) {
      setError('Could not get FeaturesApi');
      return;
    }

    const fetchData = async () => {
      try {
        const features = await featuresApi.getFeatureFlags();
        setFeatures(features.data);
      } catch (error_: unknown) {
        const error = error_ as AxiosError<string>;
        setError(error.response?.data);
      }
    };

    fetchData();
  }, [http]);

  return {
    featureFlags,
    isLoading,
    loadingError,
  };
}
